import React from 'react';
import { Box, Flex, IconButton, Text, useMediaQuery } from '@chakra-ui/react';
import { FaBell, FaHome, FaWallet, FaShoppingBasket, FaExchangeAlt, FaUser } from 'react-icons/fa';
import { Link } from 'react-router-dom';


const UserTrades = () => {
  const [isMobile] = useMediaQuery("(max-width: 768px)");

  return (
    <Box p={4}>
      {!isMobile && (
        <Flex bg="blue.200" p={2} mt={-9} mb={4} align="center" justify="space-between">
        <Link to="/user-home">
        <Text
            size="md"
            fontWeight="semibold"
            color="white"
            _hover={{ textDecoration: 'underline', borderBottom: '3px solid white' }}
        >
            Home
        </Text>
        </Link>
          <Link to="/user-wallet">
            <Text
              size="md"
              fontWeight="semibold"
              color="white"
              _hover={{ textDecoration: 'underline', borderBottom: '3px solid white' }}
            >
              Wallet
            </Text>
          </Link>
          <Link to="/user-market">
            <Text
              size="md"
              fontWeight="semibold"
              color="white"
              _hover={{ textDecoration: 'underline', borderBottom: '3px solid white' }}
            >
              Market
            </Text>
          </Link>
          <Link to="/user-trades">
            <Text
              size="md"
              fontWeight="semibold"
              color="white"
              _hover={{ textDecoration: 'underline', borderBottom: '3px solid white' }}
            >
              Trades
            </Text>
          </Link>
          <Link to="/user-account">
            <Text
              size="md"
              fontWeight="semibold"
              color="white"
              _hover={{ textDecoration: 'underline', borderBottom: '3px solid white' }}
            >
              Account
            </Text>
          </Link>          
            <Link to="/user-notifications">        
                <IconButton
                    icon={<FaBell />}
                    variant="ghost"
                    colorScheme="blue"
                    aria-label="Notifications"
                />        
            </Link>    
        </Flex>
      )}

        
{/* Main Content */}
    <Box bg="white" p={4} borderRadius="md" boxShadow="md" w={["100%", "100%", "80%"]} mx="auto">
        {/* Active Trades Section */}
        <Box bg="blue.50" p={4} borderRadius="md" mb={4} w={["100%", "100%", "70%"]} mx="auto">
            <Text fontSize="xl" fontWeight="semibold">
            Active Trades
            </Text>
            {/* ... (active trades content) */}
        </Box>

        {/* Completed Trades Section */}
        <Box bg="blue.50" p={4} borderRadius="md" mb={4} w={["100%", "100%", "70%"]} mx="auto">
            <Text fontSize="xl" fontWeight="semibold">
            Completed Trades
            </Text>
            {/* ... (completed trades content) */}
        </Box>

        {/* My Offers Section */}
        <Box bg="blue.50" p={4} borderRadius="md" mb={4} w={["100%", "100%", "70%"]} mx="auto">
            <Text fontSize="xl" fontWeight="semibold">
            My Offers
            </Text>
            {/* ... (my offers content) */}
        </Box>

        {/* Search for Offers Section */}
        <Box bg="blue.50" p={4} borderRadius="md" mb={4} w={["100%", "100%", "70%"]} mx="auto">
            <Text fontSize="xl" fontWeight="semibold">
            Search for Offers
            </Text>
            {/* ... (search for offers content) */}
        </Box>
    </Box>

      {isMobile && (
        <Flex bg="blue.200" p={2} mt={4} align="center" justify="space-between" position="fixed" bottom={0} width="95%">
            <Box textAlign="center" flex="1" p={2}>
            <Link to="/user-home">
                <Flex alignItems="center" flexDirection="column">
                <FaHome />
                <Text color="white" fontSize="xs" mt={1}>
                    Home
                </Text>
                </Flex>
            </Link>
            </Box>
            <Box textAlign="center" flex="1" p={2}>
            <Link to="/user-wallet">
                <Flex alignItems="center" flexDirection="column">
                <FaWallet />
                <Text color="white" fontSize="xs" mt={1}>
                    Wallet
                </Text>
                </Flex>
            </Link>
            </Box>
            <Box textAlign="center" flex="1" p={2}>
            <Link to="/user-market">
                <Flex alignItems="center" flexDirection="column">
                <FaShoppingBasket />
                <Text color="white" fontSize="xs" mt={1}>
                    Market
                </Text>
                </Flex>
            </Link>
            </Box>
            <Box textAlign="center" flex="1" p={2}>
            <Link to="/user-trades">
                <Flex alignItems="center" flexDirection="column">
                <FaExchangeAlt />
                <Text color="white" fontSize="xs" mt={1}>
                    Trades
                </Text>
                </Flex>
            </Link>
            </Box>
            <Box textAlign="center" flex="1" p={2}>
            <Link to="/user-notifications">
                <Flex alignItems="center" flexDirection="column">
                <FaBell />
                <Text color="white" fontSize="xs" mt={1}>
                    Notifications
                </Text>
                </Flex>
            </Link>
            </Box>
            <Box textAlign="center" flex="1" p={2}>
            <Link to="/user-account">
                <Flex alignItems="center" flexDirection="column">
                <FaUser />
                <Text color="white" fontSize="xs" mt={1}>
                    Account
                </Text>
                </Flex>
            </Link>
            </Box>
        </Flex>
        )}

    </Box>
  );
};

export default UserTrades;
